<template>
  <ul class="text-black">
    <li v-for="item in items">
      <span class="name font-red">{{item.content}} </span>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          content: "Bibliografía 1"
        },
        {
          content: "Bibliografía 2"
        },
        {
          content: "Bibliografía 3"
        },
        {
          content: "Bibliografía 4"
        }
      ]
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/variables.scss";
</style>



// WEBPACK FOOTER //
// Bibliografia.vue?49285f82